<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/commondityIndex/cManageIndex' }"
          >商品管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>商品图片设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form_container">
      <h1>商品图片设置</h1>
      <div class="content_wrap flex-rowl">
        <div class="block">
          <p><span class="mark">*</span>商品封面（缩略图）</p>
          <p class="red">JPG或者PNG格式，尺寸比例为500*500像素</p>
          <div
            class="upload_box"
            @mouseenter="enter(1)"
            @mouseleave="creenIndex = ''"
          >
            <el-upload
              action
              list-type="picture-card"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :http-request="beforeAvatarUpload"
            >
              <div v-if="formData.img">
                <img :src="formData.img" class="avatar" />
                <div
                  class="el-upload-list__item-actions flex-rowc"
                  v-show="creenIndex == 1"
                >
                  <span @click.stop="handlePictureCardPreview(formData.img, 1)"
                    ><i class="iconfont icon-fangda"></i
                  ></span>
                  <span @click.stop="handleRemove(1)"
                    ><i class="iconfont icon-icon_shanchu-"></i
                  ></span>
                </div>
              </div>

              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>

        <div class="block">
          <p><span class="mark">*</span>商品banner1</p>
          <p class="red">JPG或者PNG格式，尺寸比例为750*750像素</p>
          <div
            class="upload_box"
            @mouseenter="enter(2)"
            @mouseleave="creenIndex = ''"
          >
            <el-upload
              action
              list-type="picture-card"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :http-request="beforeAvatarUpload"
            >
              <div v-if="formData.banner">
                <img :src="formData.banner" class="avatar" />
                <div
                  class="el-upload-list__item-actions flex-rowc"
                  v-show="creenIndex == 2"
                >
                  <span @click.stop="handlePictureCardPreview(formData.img, 2)"
                    ><i class="iconfont icon-fangda"></i
                  ></span>
                  <span @click.stop="handleRemove(2)"
                    ><i class="iconfont icon-icon_shanchu-"></i
                  ></span>
                </div>
              </div>

              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>

        <div class="block">
          <p>商品banner2</p>
          <p class="red">JPG或者PNG格式，尺寸比例为750*750像素</p>
          <div
            class="upload_box"
            @mouseenter="enter(3)"
            @mouseleave="creenIndex = ''"
          >
            <el-upload
              action
              list-type="picture-card"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :http-request="beforeAvatarUpload"
            >
              <div v-if="formData.banner2">
                <img :src="formData.banner2" class="avatar" />
                <div
                  class="el-upload-list__item-actions flex-rowc"
                  v-show="creenIndex == 3"
                >
                  <span @click.stop="handlePictureCardPreview(formData.img, 3)"
                    ><i class="iconfont icon-fangda"></i
                  ></span>
                  <span @click.stop="handleRemove(3)"
                    ><i class="iconfont icon-icon_shanchu-"></i
                  ></span>
                </div>
              </div>

              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>

        <div class="block">
          <p>商品banner3</p>
          <p class="red">JPG或者PNG格式，尺寸比例为750*750像素</p>
          <div
            class="upload_box"
            @mouseenter="enter(4)"
            @mouseleave="creenIndex = ''"
          >
            <el-upload
              action
              list-type="picture-card"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :http-request="beforeAvatarUpload"
            >
              <div v-if="formData.banner3">
                <img :src="formData.banner3" class="avatar" />
                <div
                  class="el-upload-list__item-actions flex-rowc"
                  v-show="creenIndex == 4"
                >
                  <span @click.stop="handlePictureCardPreview(formData.img, 4)"
                    ><i class="iconfont icon-fangda"></i
                  ></span>
                  <span @click.stop="handleRemove(4)"
                    ><i class="iconfont icon-icon_shanchu-"></i
                  ></span>
                </div>
              </div>

              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>

        <div class="block">
          <p>商品banner4</p>
          <p class="red">JPG或者PNG格式，尺寸比例为750*750像素</p>
          <div
            class="upload_box"
            @mouseenter="enter(5)"
            @mouseleave="creenIndex = ''"
          >
            <el-upload
              action
              list-type="picture-card"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :http-request="beforeAvatarUpload"
            >
              <div v-if="formData.banner4">
                <img :src="formData.banner4" class="avatar" />
                <div
                  class="el-upload-list__item-actions flex-rowc"
                  v-show="creenIndex == 5"
                >
                  <span @click.stop="handlePictureCardPreview(formData.img, 5)"
                    ><i class="iconfont icon-fangda"></i
                  ></span>
                  <span @click.stop="handleRemove(5)"
                    ><i class="iconfont icon-icon_shanchu-"></i
                  ></span>
                </div>
              </div>

              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>

        <div class="block">
          <p>商品banner5</p>
          <p class="red">JPG或者PNG格式，尺寸比例为750*750像素</p>
          <div
            class="upload_box"
            @mouseenter="enter(6)"
            @mouseleave="creenIndex = ''"
          >
            <el-upload
              action
              list-type="picture-card"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :http-request="beforeAvatarUpload"
            >
              <div v-if="formData.banner5">
                <img :src="formData.banner5" class="avatar" />
                <div
                  class="el-upload-list__item-actions flex-rowc"
                  v-show="creenIndex == 6"
                >
                  <span @click.stop="handlePictureCardPreview(formData.img, 6)"
                    ><i class="iconfont icon-fangda"></i
                  ></span>
                  <span @click.stop="handleRemove(6)"
                    ><i class="iconfont icon-icon_shanchu-"></i
                  ></span>
                </div>
              </div>

              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>
      </div>

      <div class="form_footer flex-rowl">
        <div class="btn" @click="handleSubmit">确认</div>
        <div class="return_txt" @click="handleReturn">←返回</div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import {
  getCommidityDetail,
  editCommidity,
  uploadImage,
} from "../../../api/api";
export default {
  name: "cImages",
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,

      loading: false,

      formData: {
        Method: "ams_shop_commodity_edit",
        id: "",
        img: "",
        banner: "",
        banner2: "",
        banner3: "",
        banner4: "",
        banner5: "",
      },
      creenIndex: "",
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      let { id } = this.$route.params;
      this.loading = true;
      getCommidityDetail({ id }).then((res) => {
        this.formData.id = res.id ? res.id : "";
        this.formData.img = res.img ? res.img : "";
        this.formData.banner = res.banner ? res.banner : "";
        this.formData.banner2 = res.banner2 ? res.banner2 : "";
        this.formData.banner3 = res.banner3 ? res.banner3 : "";
        this.formData.banner4 = res.banner4 ? res.banner4 : "";
        this.formData.banner5 = res.banner5 ? res.banner5 : "";

        this.loading = false;
      });
    },
    // 移出图片
    handleRemove(isType) {
      if (isType == 1) {
        this.formData.img = "";
      } else if (isType == 2) {
        this.formData.banner = "";
      } else if (isType == 3) {
        this.formData.banner2 = "";
      } else if (isType == 4) {
        this.formData.banner3 = "";
      } else if (isType == 5) {
        this.formData.banner4 = "";
      } else if (isType == 6) {
        this.formData.banner5 = "";
      } else if (isType == 7) {
        this.formData.banner6 = "";
      }
    },
    // 大图预览
    handlePictureCardPreview(url, type) {
      if (type == 1) {
        this.dialogImageUrl = url;
      }
      this.dialogVisible = true;
    },
    // 移入图片区域
    enter(type) {
      this.creenIndex = type;
    },

    handleAvatarSuccess(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isJPG) {
        this.$message.error("缩略图只能是图片");
      }
    },
    beforeAvatarUpload(e) {
      let { creenIndex } = this;
      var formData = new FormData();
      formData.append("imgfile", e.file);
      this.loading = true;
      uploadImage(formData).then((res) => {
        if (res.result) {
          this.loading = false;
          if (creenIndex == 1) {
            this.formData.img = res.url;
          } else if (creenIndex == 2) {
            this.formData.banner = res.url;
          } else if (creenIndex == 3) {
            this.formData.banner2 = res.url;
          } else if (creenIndex == 4) {
            this.formData.banner3 = res.url;
          } else if (creenIndex == 5) {
            this.formData.banner4 = res.url;
          } else if (creenIndex == 6) {
            this.formData.banner5 = res.url;
          }
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    handleSubmit() {
      let { formData } = this;
      let params = JSON.parse(JSON.stringify(formData));
      if (params.img == "") {
        this.$message.warning("请上传商品封面缩略图");
        return;
      }
      if (params.banner == "") {
        this.$message.warning("请上传商品banner图");
        return;
      }
      this.loading = true;
      editCommidity(params).then((res) => {
        let data = res;
        if (data.result) {
          // this.loading = false;
          // let message = this.$message.success(data.message);
          // setTimeout(() => {
          //   message.close();
          //   history.back();
          // }, 1500);
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(data.message || "服务器报错，请稍后～");
        }
      });
    },
    // 图片路径的分割
    imgSplit(url) {
      if (url != "") {
        if (url.indexOf("upload")) {
          let splitArr = url.split("/upload/");
          return splitArr[splitArr.length - 1];
        } else if (url.indexOf("Upload")) {
          let splitArr = url.split("/Upload/");
          return splitArr[splitArr.length - 1];
        }
      } else {
        return "";
      }
    },

    handleReturn() {
      history.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      align-items: flex-start;
      flex-wrap: wrap;
      .block {
         margin-right: 80px;
      }
    }
  }
}
</style>